export function addDaysToCurrentDate (days) {
  const date = new Date()
  date.setDate(date.getDate() + days)

  return date
}
